export const reduxKey = '@@Gifting';
